import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";
import {
  EXPANDED_SIDEBAR_WIDTH,
  HEADER_BAR_HEIGHT
} from "../../../../constants/fixedStyleVariables";

const FOOTER_HEIGHT = 80;
export const Sidebar = styled.div`
  z-index: 9999;
  position: absolute;
  top: 0;
  right: -${EXPANDED_SIDEBAR_WIDTH}px;
  width: ${EXPANDED_SIDEBAR_WIDTH}px;
  background-color: ${Variables.colors.complementary};
  border-left: 1px solid ${Variables.colors.complementary_400};
  direction: ltr;
  text-align: right;
  //height: 100%; //prev v
  //new v {
  height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  overflow-y: auto;
  //}
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ul.sidebar-list {
    padding: 0;
    direction: rtl;
    min-height: calc(100% - ${FOOTER_HEIGHT}px - 40px);

    li {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      list-style: none;
      text-align: right;
      direction: rtl;
      font-size: ${Variables.font_sizes.x_small};
      position: relative;
      //width: auto;
      //height: 32px;
      margin: auto;
      //padding: 8px 20px;
      border-radius: unset;

      a {
        padding: 8px 20px;
        width: auto;
        height: 32px;
        color: ${Variables.colors.complementary_900};
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:hover,
        &:active,
        &:visited {
          color: ${Variables.colors.complementary_900};
        }
        .sidebar-disabled-link {
          cursor: not-allowed !important;
        }
        &.active {
          //padding: 0;
          path {
            fill: ${props => props.color};
          }
          li {
            color: ${props => props.color};
            background-color: ${props => props.backgroundcolor};

            i {
              &:before {
                color: ${props => props.color};
              }
            }
            &:hover,
            &:active,
            &:visited {
              color: ${props => props.color};
            }
          }
        }
        span {
          display: flex;
          align-items: center;
        }
        .premium-icon {
          margin-right: 4px;
          &:before {
            font-size: 14px;
            color: ${Variables.colors.yellow_500};
          }
        }

        .sidebar-badge {
          display: none;
          position: absolute;
          top: 8px;
          left: 8px;
          width: 16px;
          height: 16px;
          i.external-link-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 16px;
            &:before {
              margin: 0;
              font-size: 16px;
              color: ${Variables.colors.complementary_500};
            }
          }
        }

        i {
          &:before {
            color: ${Variables.colors.complementary_600};
            margin-left: 9px;
            font-size: 18px;
          }
        }
        svg {
          margin-left: 9px;
          path {
            fill: ${Variables.colors.complementary_600};
          }
        }
      }

      &:hover {
        background-color: ${Variables.colors.complementary_200};
        border-radius: 4px;
        //padding: 8px 20px;
        .sidebar-badge {
          display: block;
        }
      }
    }
  }
  .sidebar-footer {
    margin-right: 12px;
    padding: 20px 11px 0 4px;
    direction: rtl;
    text-align: right;
    background-color: ${Variables.colors.complementary};
    a {
      text-decoration: none;
      color: ${Variables.colors.complementary_600};
      &:hover,
      &:visited,
      &:focus {
        color: ${Variables.colors.complementary_600};
      }
    }
    .circle-separator {
      width: 4px;
      height: 4px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 2px;
      content: " ";
      border-radius: 50%;
      background-color: ${Variables.colors.complementary_700};
    }
    .copyright {
      line-height: normal;
      color: ${Variables.colors.complementary_500};
      font-size: ${Variables.font_sizes.small};
      font-weight: ${Variables.font_weight.light};
    }
    div {
      color: ${Variables.colors.complementary_600};
      font-size: ${Variables.font_sizes.x_small};
      padding-bottom: 7px;
    }
  }
`;

export const StyledCardListOfLinks = styled.div`
  background-color: ${Variables.colors.white};
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  padding: 8px 0;
  margin-top: 8px;
  .title {
    font-size: ${Variables.font_sizes.medium};
    color: ${Variables.colors.complementary_600};
    margin-bottom: 16px;
    padding: 0 16px;
  }
`;
